import { useHistory, useParams } from 'react-router'

import ActionIcon from 'common/components/ActionIcon'
import { ArrowLeft } from 'common/icons'

import useGetExperimentsQuery from '../api/queries/useGetExperimentsQuery'

import HeaderActions from './HeaderActions'

const Header = () => {
  const history = useHistory()

  const { data: experiments = [] } = useGetExperimentsQuery()
  const { id } = useParams<{ id: string }>()
  const experimentName = experiments.find((e) => e.id === id)?.name

  return (
    <div className="flex flex-none items-center border-b-1 border-coolGray-200 h-14 py-2 px-6">
      <div className="flex-1 flex justify-between">
        <div className="flex justify-center items-center">
          <ActionIcon onClick={() => history.push('/personalization')}>
            <ArrowLeft className="cursor-pointer" />
          </ActionIcon>
          <span className="text-lg font-medium text-coolGray-800 ml-2 break-all">
            {experimentName}
          </span>
        </div>
        <HeaderActions />
      </div>
    </div>
  )
}

export default Header
